import { 
  // DashboardOutlined, 
  // AppstoreOutlined,
  // AntDesignOutlined,
  // InfoCircleOutlined,
  // CompassOutlined,
  // LayoutOutlined,
  // BookOutlined
} from '@ant-design/icons';
// eslint-disable-next-line no-unused-vars
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from 'configs/AppConfig'

// const loginNavTree = [{
//   key: 'login',
//   //path: `${process.env.REACT_APP_DEV_API_REDIRECT_URL}`,
//   title: "LOGIN",
//   // icon: DashboardOutlined,
//   breadcrumb: false,
//   submenu: [],
// }]

const homeNavTree = [{
  key: 'home',
  path: `${AUTH_PREFIX_PATH}/home`,
  title: 'home',
  // icon: DashboardOutlined,
  breadcrumb: false,
  submenu: []
}]

const scheduleNavTree = [{
  key: 'schedule',
  path: `${AUTH_PREFIX_PATH}/schedule`,
  title: 'game.schedule',
  // icon: AppstoreOutlined,
  breadcrumb: false,
  submenu: []
}]

const scheduledNavTree = [{
  key: 'scheduled',
  path: `${AUTH_PREFIX_PATH}/scheduled`,
  title: 'game.schedule',
  // icon: AppstoreOutlined,
  breadcrumb: false,
  submenu: []
}]

const standingsNavTree = [{
  key: 'standings',
  path: `${AUTH_PREFIX_PATH}/standings`,
  title: 'game.standings',
  // icon: AppstoreOutlined,
  breadcrumb: false,
  submenu: []
}]

const statsNavTree = [
  {
    key: 'stats',
    path: `${AUTH_PREFIX_PATH}/stats`,
    title: 'sidenav.stats',
    // icon: AntDesignOutlined,
    breadcrumb: true,
    submenu:[]
  }
]

const newspageNavTree = [
  {
    key: 'newspage',
    path: `${AUTH_PREFIX_PATH}/newspage`,
    title: 'news',
    // icon: AntDesignOutlined,
    breadcrumb: true,
    submenu:[]
  }
]

// const underTree = [{
//   key: 'under',
//   path: `${AUTH_PREFIX_PATH}/under`,
//   title: 'game.under',
//   // icon: BookOutlined,
//   breadcrumb: false,
//   submenu: []
// }]

// const coedTree = [{
//   key: 'coed',
//   path: `${APP_PREFIX_PATH}/docs`,
//   title: 'coed',
//   // icon: BookOutlined,
//   breadcrumb: false,
//   submenu: []
// }]

const rules = [{
  key: 'regulations',
  path: `${AUTH_PREFIX_PATH}/regulations`,
  title: 'rules.regulations',
  // icon: BookOutlined,
  breadcrumb: false,
  submenu: []
}]

// const faq = [{
//   key: 'faq',
//   path: `${AUTH_PREFIX_PATH}/faq`,
//   title: 'faq',
//   // icon: BookOutlined,
//   breadcrumb: false,
//   submenu: []
// }]

const navigationConfig = [
  //...((process.env.REACT_APP_DEV_API_REDIRECT_URL).includes('tcbl'))?loginNavTree:[],
  ...((process.env.REACT_APP_DEV_API_REDIRECT_URL).includes('tcbl'))?[]:homeNavTree,
  ...standingsNavTree,
  ...((process.env.REACT_APP_DEV_API_REDIRECT_URL).includes('tcbl'))?scheduleNavTree:[],
  ...((process.env.REACT_APP_DEV_API_REDIRECT_URL).includes('tcbl'))?[]:scheduledNavTree,
  ...statsNavTree,
  ...newspageNavTree,
  // ...((process.env.REACT_APP_DEV_API_REDIRECT_URL).includes('tcbl'))?underTree:[],
  // ...((process.env.REACT_APP_DEV_API_REDIRECT_URL).includes('tcbl'))?coedTree:[],
  ...rules,
  // ...((process.env.REACT_APP_DEV_API_REDIRECT_URL).includes('tcbl'))?faq:[]
]

export default navigationConfig;
